import React from 'react';
import { DropdownMenu, DropdownMenuItem, TextButton, Tooltip, Typography } from 'seagull';
import styles from "./AddNewItemButtons.module.scss";
const AddNewItemButtons = _ref => {
  let {
    serviceOptions,
    handleAddServiceFromAgreement,
    handleAddOutOfScopeCharge
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(TextButton, {
    underline: false,
    "data-testid": "add-charge-out-of-scope-button",
    onClick: handleAddOutOfScopeCharge
  }, "+ Add an out of scope charge"), serviceOptions.length > 0 ? /*#__PURE__*/React.createElement(DropdownMenu, {
    hAlign: "left",
    maxHeight: 200,
    width: 320,
    target: /*#__PURE__*/React.createElement(TextButton, {
      underline: false,
      "data-testid": "add-service-from-agreement-button"
    }, "+ Add a service listed in the agreement")
  }, serviceOptions.map((_ref2, index) => {
    let {
      name,
      costString,
      disabledReason,
      id
    } = _ref2;
    return /*#__PURE__*/React.createElement(DropdownMenuItem, {
      key: id,
      height: 56,
      skin: "primary",
      "data-testid": "service-from-agreement-option-".concat(index),
      onClick: () => handleAddServiceFromAgreement(id),
      disabled: disabledReason.isDisabled,
      tooltipProps: disabledReason.isDisabled ? {
        title: disabledReason.reasonTooltip,
        placement: 'right'
      } : undefined
    }, /*#__PURE__*/React.createElement(Typography, {
      ellipsis: true,
      className: styles.menuItem,
      variant: "paragraph1",
      "data-testid": "option-".concat(index, "-title")
    }, name), /*#__PURE__*/React.createElement(Typography, {
      className: styles.menuItem,
      ellipsis: true,
      variant: "paragraph1",
      skin: "secondary"
    }, costString));
  })) : /*#__PURE__*/React.createElement(Tooltip, {
    title: "No manual services are available for billing.",
    placement: "bottom-start"
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "disabled",
    variant: "paragraph1",
    "data-testid": "add-service-from-agreement-tooltip"
  }, "+ Add a service listed in the agreement")));
};
export default AddNewItemButtons;